import { Component, OnInit, Directive, Input, HostListener, ViewChild } from '@angular/core';

import { Router } from '@angular/router';
import { CognitoUtil } from '../../../../shared/services/cognito.service';
import { ReportsService } from '../../../../shared/services/reports.service';
import { LocalUserService } from '../../../../shared/services/localUser';
import { Subject } from 'rxjs/Subject';
import { Chart } from 'chart.js';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CaseStatus } from 'aws-sdk/clients/support';
import { PageEvent, MatPaginator, MatTableDataSource } from '@angular/material';

@Component({
    selector: 'case-status-reports',
    templateUrl: './case.status.reports.html',
    providers: [
        LocalUserService
    ]
})
export class CaseStatusReportsComponent implements OnInit {


    @ViewChild('caseStatusTable') caseStatusTable: any;

    @ViewChild('pendingCasesTable') pendingCasesTable: any;

    @Input() userAttributes: Subject<any>;

    view: any[] = [null, 400];
    displayedColumns: string[] = ['case_number', 'created_date','modified_date', 'status'];
    
  @ViewChild(MatPaginator) set matPaginator(paginator: MatPaginator) {
    this.tableData.paginator = paginator;
    }

    showTable = false;

    orgId = null;
    userId = null;
    token: string;


    loading = true;

    caseStatusReports = {};
    caseStatusReportsChartData = [];

    pendingCasesData = {};

    pendingCasesChartData = [];

    pendingCasesTableData = [];

    showPendingCasesTable = false;

    chartLabel = [];

    chartData = [];
    chartColors = [];
    error: string;
    color = ['#49AFD9', '#A6D8E7', '#C1CDD4', '#798893', '#00B7D6', '#b30000', '#ff66d9', '#e60000', '#0065AB', '#ff00ff', '#000099', '#ff9933', '#33ff33', '#ff6633', '#00ffff', '#40ff00', '#ff4000', '#ffff00'];

    colorScheme = {
        domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
    };

    // pie
    explodeSlices = false;

    tableData = new MatTableDataSource<any>();
    // length: number = 0;
    // pageSize: number = 2;
    // pageSizeOptions: number[] = [2, 4, 6, 8];

    toolTipGenerator = function (event) {
        let text;
        if (event && event.data) {
            text = `${event.data.name} - ${event.data.value}`;
        }
        return text;
    };
    constructor(
        private reportsService: ReportsService,
        private router: Router,
        private cognito: CognitoUtil,
        private localUser: LocalUserService,
        public snackBar: MatSnackBar,

    ) {

    }

    ngOnInit() {
        this.userId = this.localUser.getUserId();
        this.orgId = this.localUser.getOrganizationId();
        this.getCaseStatusReports();
    }

    onCaseStatusSectorSelect(event) {
        this.loading = true
        this.reportsService.getReportsCases(this.orgId, this.userId, 'CaseStatusPieChart', event)
            .subscribe(result => {
                this.tableData.data = result;
                this.showTable = true;
                this.loading = false

            }, error => {
                this.loading = false;
                this.error = 'Server Not Responding';
                this.snackBar.open(this.error, '', {
                    duration: 2000,
                });
            })
    }

    /* onChartClick(event , tableData , reportsData) {
        this[tableData] = reportsData[event.name];
        this.showTable = true;
    } */

    dynamicColors() {
        var r = Math.floor(Math.random() * 255);
        var g = Math.floor(Math.random() * 255);
        var b = Math.floor(Math.random() * 255);
        return "rgb(" + r + "," + g + "," + b + ")";
    };
    getCaseStatusReports() {
        this.reportsService.getCaseStatusReports(this.orgId, this.userId)
            .subscribe((data) => {

                let keys = Object.keys(data);
                let formedData = [];

                for (let i = 0; i < keys.length; i++) {
                    let newObject = {
                        name: keys[i],
                        value: data[keys[i]]
                    };
                    formedData.push(newObject);
                }

                this.caseStatusReportsChartData = formedData;
                this.loading = false;
                let index = 0;
                this.caseStatusReportsChartData.forEach(item => {
                    this.chartLabel.push(item.name);
                    this.chartData.push(item.value);
                    // this.chartColors.push(this.dynamicColors());
                    this.chartColors.push(this.color[index]);
                    index = index + 1;
                });
                this.barChart();
            }, error => {
                this.loading = false;
                this.error = 'Server Not Responding';
                this.snackBar.open(this.error, '', {
                    duration: 2000,
                });
            });


    }

    barChart() {
        $('#statusChart').remove()
        $('#parentStatus').append('<canvas id="statusChart"></canvas>')
        var ctx = document.getElementById("statusChart")
        new Chart(ctx, {
            type: 'horizontalBar',
            data: {
                labels: this.chartLabel,
                datasets: [
                    {
                        label: "",
                        backgroundColor: this.chartColors,
                        data: this.chartData
                    }
                ]
            },
            options: {
                onClick: (mouseEvent, chart) => {
                    let index = chart[0]._index
                    let type = this.chartLabel[index]
                    this.onCaseStatusSectorSelect(type)
                },
                legend: { display: false },
                scales: {
                    xAxes: [{
                        ticks: {
                            min: 0,
                            stepSize: 1,

                        },
                        scaleLabel: {
                            display: true,
                            labelString: 'No. of Cases'
                        }
                    }],
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Status'
                        }
                    }]
                },
                title: {
                    display: true,
                    text: 'Case Status'
                }
            }
        });


    }

    onPendingStatusSectorSelect(event) {
        this.showPendingCasesTable = true;
        this.pendingCasesTableData = this.pendingCasesData[(event.name ? event.name : event)];
    }

    toggleExpandRow(row, tableType) {
        this[tableType].rowDetail.toggleExpandRow(row);
    }

    onDetailToggle(event) {
    }

    openCase(row) {
        this.router.navigate(['case', row.caseSummary.organization_id, row.id]);
    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/reports/case-status/case.status.reports.ts